import { D2CCompanyProfileDto, Nullable } from '@orcar/common';
import { Viewer } from '@orcar/common-d2c';
import { MutableRefObject } from 'react';
import styled from 'styled-components';

interface CompanyInfoProps {
  company?: D2CCompanyProfileDto;
  isMobile: boolean;
  tabRef?: MutableRefObject<Nullable<HTMLDivElement>[]>;
  hasPadding?: boolean;
}

const CompanyInfo = ({
  company,
  isMobile,
  tabRef,
  hasPadding,
}: CompanyInfoProps) => {
  return (
    <ContentWrapper
      ref={(ref) => (tabRef ? (tabRef.current[2] = ref) : null)}
      hasPadding={hasPadding}
    >
      <SectionTitle isMobile={isMobile}>{company?.name}</SectionTitle>
      <FlexColWrapper gap='12px'>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>인수/반납 장소</InfoTitle>
          <InfoText>{company?.address}</InfoText>
        </InfoWrapper>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>전화번호</InfoTitle>
          <InfoText>{company?.phoneNumber}</InfoText>
        </InfoWrapper>
        <InfoWrapper isMobile={isMobile}>
          <InfoTitle>무료 셔틀 정보</InfoTitle>
          <Viewer
            content={company?.freeShuttleInfo || ''}
            style={{ lineHeight: '27px' }}
          />
        </InfoWrapper>
      </FlexColWrapper>
    </ContentWrapper>
  );
};

export { CompanyInfo };

const InfoWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => isMobile && 'column'};
  white-space: pre-line;
`;

const ContentWrapper = styled.div<{
  hasPadding?: boolean;
  isMobile?: boolean;
}>`
  width: 100%;
  padding: ${({ hasPadding }) => hasPadding && '30px 0'};
  scroll-margin: ${({ isMobile }) => (isMobile ? '110px' : '150px')};
`;

const FlexColWrapper = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap};
`;

const InfoTitle = styled.p`
  min-width: 110px;
  ${({ theme }) => theme.FONT.B1};
  font-weight: 600;
  line-height: 27px;
`;

const InfoText = styled.p`
  width: fit-content;
  ${({ theme }) => theme.FONT.B1};
  word-break: keep-all;
`;

export const SectionTitle = styled.p<{
  isMobile: boolean;
}>`
  margin-bottom: 20px;
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.H4 : theme.FONT.H5)};
`;
